var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "modalNotificar",
      attrs: { titulo: _vm.titulo(), width: _vm.width },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _vm.showModalNotificacao
            ? _c("app-modal-selecionar-modelo-notificacao", {
                attrs: {
                  tiposModelo: _vm.tiposModelo,
                  titulo: "Modelos de Notificação",
                  idProcesso: this.idProcesso,
                  showModal: _vm.showModalNotificacao
                },
                on: {
                  closeModal: _vm.fecharModalNotificacao,
                  setTextoNotificacao: _vm.setTextoNotificacao
                }
              })
            : _vm._e(),
          _c("p"),
          _vm._l(_vm.conversas, function(item) {
            return _vm.conversas.length > 0 &&
              _vm.conversas.tipo === "SINALIZACAO_PENDENCIA"
              ? _c(
                  "div",
                  { key: item.id, staticClass: "mb" },
                  [
                    _c("p", [
                      _c("b", [_vm._v("Sinalização:  " + _vm._s(item.assunto))])
                    ]),
                    _c(
                      "el-collapse",
                      _vm._l(item.mensagemList, function(msg) {
                        return _c(
                          "el-collapse-item",
                          { key: msg.id, attrs: { name: msg.id } },
                          [
                            _c("template", { slot: "title" }, [
                              _c(
                                "div",
                                { staticClass: "flex title full-width" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(msg.nomeRemetente))
                                  ]),
                                  _c("span", [
                                    _vm._v(_vm._s(msg.dataEnviada) + "  ")
                                  ])
                                ]
                              )
                            ]),
                            _c("el-row", { staticClass: "margin-top" }, [
                              _c("p", {
                                domProps: { innerHTML: _vm._s(msg.conteudo) }
                              })
                            ])
                          ],
                          2
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          }),
          _c("div", { staticClass: "display-flex" }, [
            _c(
              "div",
              { staticClass: "label-width" },
              [
                _c("app-label", {
                  attrs: { label: "Mensagem:", required: true }
                })
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.openModalNotificacao()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "center" }, [
                      _c("i", { staticClass: "fa fa-file icon" }),
                      _c("b", [_vm._v("  Modelo")])
                    ])
                  ]
                )
              ],
              1
            )
          ]),
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("app-editor-texto", {
                      ref: "editorTexto",
                      staticClass: "input",
                      class: { erro: errors.length },
                      attrs: { value: _vm.mensagem },
                      on: { onTextChange: _vm.onTextChange }
                    }),
                    _c("span", { staticClass: "help erro" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("h4", [_vm._v("Anexos mensagem")]),
          _c("app-anexo", {
            attrs: {
              id: "upload-notificacao",
              exibirDownload: false,
              files: _vm.anexos,
              scope: "anexos"
            },
            on: { removeFile: _vm.removeFile, uploadFile: _vm.uploadFile },
            model: {
              value: _vm.anexos,
              callback: function($$v) {
                _vm.anexos = $$v
              },
              expression: "anexos"
            }
          })
        ],
        2
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "default", size: "small" },
                on: {
                  click: function($event) {
                    return _vm.$emit("closeModal")
                  }
                }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "fa fa-times" }),
                  _c("b", [_vm._v("  Cancelar")])
                ])
              ]
            ),
            _vm.isNovaConversa
              ? _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "success", size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.checkValidacao()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "center" }, [
                      _c("i", { staticClass: "fa fa-share-square" }),
                      _c("b", [_vm._v("  Enviar")])
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-946914e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-946914e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/AppModalSinalizarPendencia.vue
// module id = null
// module chunks = 